import { render, staticRenderFns } from "./pbx-search.vue?vue&type=template&id=5d6d9eba&scoped=true&"
import script from "./pbx-search.vue?vue&type=script&lang=ts&"
export * from "./pbx-search.vue?vue&type=script&lang=ts&"
import style0 from "./pbx-search.vue?vue&type=style&index=0&id=5d6d9eba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6d9eba",
  null
  
)

export default component.exports